/**
 * Header used to pass audit log reasons in requests.
 */
export const AUDIT_LOG_REASON_HEADER = 'x-flux-audit-reason';

/**
 * Maximum length for audit log reason.
 */
export const AUDIT_LOG_REASON_MAX_LENGTH = 512;
